module.exports = __webpack_public_path__ + "08_long_gold.04c0215d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_long_gold.png
// module id = aFtM
// module chunks = 0